import appContractorInvoice from "../../views/appCustomers/contractorInvoice.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("contractorinvoice", {
    url: "contractor-invoice/:id",
    parent: "app",
    views: {
      view: {
        template: appContractorInvoice,
      },
    },
    reloadOnSearch: false,
    data: { title: "ContractorInvoice" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoice/contractorInvoice.urls.js